import React from 'react'

const Spinner = (props: any) => <div className={'spinner ease-linear rounded-full border-gray-200 h-4 w-4 ' + (props.className || '')} />

export default Spinner
